module.exports = require("rxjs/BehaviorSubject");


//////////////////
// WEBPACK FOOTER
// external "rxjs/BehaviorSubject"
// module id = 21
// module chunks = 0